import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import heroM6Dm from '../images/bydm6dm/blog-1.jpeg';
import frontM6Dm from '../images/bydm6dm/m6dmextfront-3.webp';
import sideM6Dm from '../images/bydm6dm/m6dmextside-2.webp';
import interiorDashM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM (1).jpeg';
import interiorClusterM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM.jpeg';
import interiorCabinM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM (1).jpeg';
import interiorSeatM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.34 AM (2).jpeg';
import interiorPanoramicM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM.jpeg';
import interiorRoofM6Dm from '../images/bydm6dm/WhatsApp Image 2026-05-18 at 9.18.33 AM (2).jpeg';
import PageSeo, {
  articleJsonLd,
  breadcrumbJsonLd,
  keywordSets,
  localBusinessJsonLd,
} from '../PageSeo';

const waLink =
  'https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20ingin%20info%20BYD%20M6%20DM%20Indonesia%2C%20harga%2C%20dan%20jadwal%20test%20drive%20di%20BYD%20BSD%20Serpong';

const articleSections = [
  {
    title: 'Apa itu BYD M6 DM?',
    text: 'BYD M6 DM adalah MPV dengan teknologi Dual Mode. Cara mudah memahaminya: ini mobil keluarga yang punya karakter berkendara listrik, tetapi tetap memiliki mesin bensin untuk membantu perjalanan jauh. Karena itu, M6 DM cocok untuk pembeli yang tertarik dengan mobil listrik, tetapi masih ingin fleksibilitas bahan bakar.',
  },
  {
    title: 'Kenapa teknologi DM relevan untuk Indonesia?',
    text: 'Rute harian di kota biasanya pendek dan padat, sehingga tenaga listrik terasa paling masuk akal: halus, senyap, dan responsif. Namun keluarga Indonesia juga sering melakukan perjalanan antar kota. Di sinilah sistem DM menjadi menarik karena baterai, motor listrik, dan mesin bensin bisa bekerja bersama untuk menjaga efisiensi dan jarak tempuh.',
  },
  {
    title: 'Performa dan daya jelajah',
    text: 'Angka utama yang perlu diperhatikan adalah akselerasi 0-100 km/h dalam 10.1 detik, baterai 18 kWh, tangki bahan bakar 52 liter, dan range hingga 1200 km NEDC. Kombinasi ini membuat BYD M6 DM bukan hanya MPV untuk dalam kota, tetapi juga opsi realistis untuk perjalanan keluarga jarak jauh.',
  },
  {
    title: 'Harga BYD M6 DM',
    text: 'Harga BYD M6 DM masih coming soon. Untuk pembeli di BSD, Tangerang, Gading Serpong, dan Tangerang Selatan, langkah paling aman adalah menghubungi Junius di BYD BSD Serpong agar bisa mendapatkan update harga, estimasi ketersediaan unit, promo, dan jadwal test drive.',
  },
];

const quickSpecs = [
  { label: '0 - 100 km/h', value: '10.1s' },
  { label: 'Battery capacity', value: '18 kWh' },
  { label: 'Fuel capacity', value: '52 L' },
  { label: 'Range NEDC', value: '1200 km' },
];

const interiorItems = [
  {
    image: interiorDashM6Dm,
    title: 'Speedometer digital',
    text: 'Panel speedometer digital menampilkan status HEV, konsumsi energi, tekanan ban, dan data perjalanan.',
  },
  {
    image: interiorClusterM6Dm,
    title: 'Kursi penumpang',
    text: 'Kursi penumpang terlihat lega dengan armrest dan posisi duduk yang nyaman untuk keluarga.',
  },
  {
    image: interiorCabinM6Dm,
    title: 'Kursi depan, tengah, dan row 3',
    text: 'Sudut foto ini memperlihatkan susunan kabin dari kursi depan, baris tengah, sampai row 3.',
  },
  {
    image: interiorSeatM6Dm,
    title: 'Kursi depan',
    text: 'Tampilan kursi depan memperlihatkan posisi duduk pengemudi dan penumpang depan dengan konsol tengah yang praktis.',
  },
  {
    image: interiorPanoramicM6Dm,
    title: 'Dashboard dan setir',
    text: 'Bagian dashboard dan setir memperlihatkan layar tengah, panel instrumen, dan layout kontrol pengemudi.',
  },
  {
    image: interiorRoofM6Dm,
    title: 'Fokus setir',
    text: 'Foto ini menonjolkan setir multifungsi BYD M6 DM dan tombol kontrol yang mudah dijangkau.',
  },
];

const faqItems = [
  {
    question: 'Apakah BYD M6 DM mobil listrik atau hybrid?',
    answer:
      'BYD M6 DM adalah plug-in hybrid dengan teknologi Dual Mode. Mobil ini menggabungkan motor listrik, baterai, dan mesin bensin.',
  },
  {
    question: 'Apakah BYD M6 DM bisa diisi bensin?',
    answer:
      'Bisa. M6 DM tetap memiliki tangki bahan bakar, sehingga lebih fleksibel untuk perjalanan jauh dibanding mobil listrik murni.',
  },
  {
    question: 'Berapa range BYD M6 DM?',
    answer:
      'Data awal yang digunakan di halaman ini adalah range hingga 1200 km NEDC, dengan baterai 18 kWh dan tangki bahan bakar 52 liter.',
  },
  {
    question: 'Kapan harga BYD M6 DM diumumkan?',
    answer:
      'Harga BYD M6 DM masih coming soon. Hubungi Junius di BYD BSD Serpong untuk update harga dan ketersediaan unit.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

function M6DMDetail() {
  return (
    <>
      <PageSeo
        title='BYD M6 DM Indonesia 2026 | MPV PHEV 1200 KM NEDC'
        description='BYD M6 DM Indonesia hadir sebagai MPV plug-in hybrid Dual Mode: 10.1s 0-100 km/h, baterai 18 kWh, tangki 52 liter, range 1200 km NEDC, dan harga coming soon.'
        keywords={[
          ...keywordSets.localDealer,
          'BYD M6 DM Indonesia',
          'BYD M6 DM',
          'harga BYD M6 DM',
          'BYD M6 DM BSD Serpong',
          'M6 DM plug-in hybrid',
          'mobil listrik bisa bensin',
          'BYD M6 hybrid Indonesia',
          'BYD M6 PHEV',
          'interior BYD M6 DM',
          'kabin BYD M6 DM',
        ]}
        path='/blog/byd-m6-dm-indonesia'
        image={heroM6Dm}
        type='article'
        jsonLd={[
          localBusinessJsonLd(),
          articleJsonLd({
            title: 'BYD M6 DM Indonesia 2026 | MPV PHEV 1200 KM NEDC',
            description:
              'Penjelasan BYD M6 DM sebagai MPV plug-in hybrid Dual Mode untuk keluarga Indonesia, lengkap dengan spesifikasi awal dan status harga coming soon.',
            image: heroM6Dm,
            path: '/blog/byd-m6-dm-indonesia',
            datePublished: '2026-05-18',
            dateModified: '2026-05-18',
          }),
          breadcrumbJsonLd([
            { name: 'Beranda', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: 'BYD M6 DM Indonesia', path: '/blog/byd-m6-dm-indonesia' },
          ]),
          faqJsonLd,
        ]}
      />

      <Box component='main' sx={{ backgroundColor: '#f4f7fb', overflow: 'hidden' }}>
        <HeroSection />
        <ArticleSection />
        <SpecSection />
        <UseCaseSection />
        <InteriorExampleSection />
        <FaqSection />
        <CtaSection />
      </Box>
    </>
  );
}

function HeroSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-blog-title'
      sx={{
        position: 'relative',
        minHeight: { xs: '88vh', md: '95vh' },
        display: 'flex',
        alignItems: 'flex-end',
        pt: { xs: 10, md: 11 },
        backgroundColor: '#111827',
      }}
    >
      <Box
        component='img'
        src={heroM6Dm}
        alt='BYD M6 DM Indonesia'
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(180deg, rgba(0,0,0,0.28) 0%, rgba(0,0,0,0.14) 42%, rgba(0,0,0,0.82) 100%)',
        }}
      />
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          width: '100%',
          maxWidth: 1180,
          mx: 'auto',
          px: { xs: 2, md: 5 },
          pb: { xs: 5, md: 7 },
          color: '#fff',
        }}
      >
        <Typography sx={eyebrowDark}>BYD M6 DM Indonesia</Typography>
        <Typography id='m6dm-blog-title' component='h1' sx={heroTitle}>
          Mobil listrik yang bisa diisi bensin, dibuat untuk keluarga jarak jauh
        </Typography>
        <Typography sx={heroText}>
          BYD M6 DM membawa teknologi Dual Mode ke kelas MPV keluarga. Fokusnya
          jelas: rasa berkendara listrik untuk harian, fleksibilitas bensin
          untuk perjalanan panjang, dan range hingga 1200 km NEDC.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
          <Button
            href={waLink}
            target='_blank'
            rel='noopener noreferrer'
            variant='contained'
            sx={buttonPrimary}
          >
            Tanya Harga M6 DM
          </Button>
          <Button
            component={RouterLink}
            to='/jelajahi-m6-dm'
            variant='outlined'
            sx={buttonGhost}
          >
            Lihat halaman model
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

function ArticleSection() {
  return (
    <Box
      component='article'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}
    >
      <Box sx={{ maxWidth: 920, mx: 'auto' }}>
        <Typography sx={eyebrow}>Penjelasan Teknologi DM</Typography>
        <Typography component='h2' sx={sectionTitle}>
          BYD M6 DM bukan sekadar M6 dengan mesin tambahan
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5 }}>
          Daya tarik utama M6 DM ada pada cara sistemnya memadukan dua sumber
          energi. Mobil ini tetap membawa identitas BYD sebagai produsen EV,
          tetapi menambahkan fleksibilitas mesin bensin agar pemilik tidak
          terlalu bergantung pada charging saat rute berubah atau perjalanan
          makin jauh.
        </Typography>

        <Box sx={{ mt: 3, display: 'grid', gap: 2.2 }}>
          {articleSections.map((section) => (
            <Box key={section.title}>
              <Typography component='h3' sx={{ fontWeight: 900, fontSize: '1.35rem' }}>
                {section.title}
              </Typography>
              <Typography sx={{ ...bodyText, mt: 0.8 }}>{section.text}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function SpecSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-spec-blog-title'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Spesifikasi BYD M6 DM</Typography>
        <Typography id='m6dm-spec-blog-title' component='h2' sx={sectionTitle}>
          Spesifikasi yang banyak dicari calon pembeli
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
            gap: 2,
          }}
        >
          {quickSpecs.map((item) => (
            <Box key={item.label} sx={infoCard}>
              <Typography sx={{ fontSize: '2rem', fontWeight: 900, color: '#111827' }}>
                {item.value}
              </Typography>
              <Typography sx={{ mt: 0.5, color: '#4b5563', fontWeight: 800 }}>
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function UseCaseSection() {
  const items = [
    {
      image: frontM6Dm,
      title: 'Untuk mobilitas harian',
      text: 'Saat dipakai di kota, karakter listrik membuat akselerasi terasa halus dan kabin lebih tenang.',
    },
    {
      image: sideM6Dm,
      title: 'Untuk perjalanan keluarga',
      text: 'Range 1200 km NEDC dan tangki 52 liter memberi fleksibilitas lebih saat rute keluar kota.',
    },
  ];

  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 }, backgroundColor: '#fff' }}>
      <Box
        sx={{
          maxWidth: 1180,
          mx: 'auto',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 2.5,
        }}
      >
        {items.map((item) => (
          <Box key={item.title} sx={imageCard}>
            <Box
              component='img'
              src={item.image}
              alt={item.title}
              sx={{ width: '100%', height: { xs: 230, md: 300 }, objectFit: 'cover', display: 'block' }}
            />
            <Box sx={{ p: 2.4 }}>
              <Typography component='h3' sx={{ fontSize: '1.35rem', fontWeight: 900 }}>
                {item.title}
              </Typography>
              <Typography sx={{ ...bodyText, mt: 0.8 }}>{item.text}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

function InteriorExampleSection() {
  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}>
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography sx={eyebrow}>Contoh Interior BYD M6 DM</Typography>
        <Typography component='h2' sx={sectionTitle}>
          Gambaran kabin sebelum datang lihat unit
        </Typography>
        <Typography sx={{ ...bodyText, mt: 1.5, maxWidth: 840 }}>
          Selain teknologi Dual Mode, calon pembeli biasanya ingin tahu suasana
          kabin. Foto ini memperlihatkan speedometer digital, kursi penumpang,
          susunan tiga baris kursi, dashboard, dan setir BYD M6 DM.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(3, 1fr)' },
            gap: 2,
          }}
        >
          {interiorItems.map((item) => (
            <Box key={item.title} sx={imageCard}>
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                loading='lazy'
                sx={{
                  width: '100%',
                  height: { xs: 230, md: 260 },
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <Box sx={{ p: 2.4 }}>
                <Typography component='h3' sx={{ fontSize: '1.18rem', fontWeight: 900 }}>
                  {item.title}
                </Typography>
                <Typography sx={{ ...bodyText, mt: 0.8, fontSize: '0.96rem' }}>
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function FaqSection() {
  return (
    <Box
      component='section'
      aria-labelledby='m6dm-faq-blog-title'
      sx={{ px: { xs: 2, md: 6 }, py: { xs: 7, md: 9 } }}
    >
      <Box sx={{ maxWidth: 920, mx: 'auto' }}>
        <Typography id='m6dm-faq-blog-title' component='h2' sx={sectionTitle}>
          FAQ BYD M6 DM
        </Typography>
        <Box sx={{ mt: 2.5, display: 'grid', gap: 1.3 }}>
          {faqItems.map((item) => (
            <Box
              key={item.question}
              component='details'
              sx={{
                p: 2,
                borderRadius: '8px',
                backgroundColor: '#fff',
                border: '1px solid rgba(17,24,39,0.08)',
                '& summary': {
                  cursor: 'pointer',
                  fontWeight: 900,
                  color: '#111827',
                },
              }}
            >
              <Box component='summary'>{item.question}</Box>
              <Typography sx={{ mt: 1.2, color: '#4b5563', lineHeight: 1.75 }}>
                {item.answer}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

function CtaSection() {
  return (
    <Box component='section' sx={{ px: { xs: 2, md: 6 }, pb: { xs: 7, md: 9 } }}>
      <Box
        sx={{
          maxWidth: 1080,
          mx: 'auto',
          borderRadius: '8px',
          backgroundColor: '#111827',
          color: '#fff',
          px: { xs: 2.5, md: 4 },
          py: { xs: 3.5, md: 4.5 },
          textAlign: 'center',
        }}
      >
        <Typography component='h2' sx={sectionTitleDark}>
          Ingin masuk waiting list BYD M6 DM?
        </Typography>
        <Typography sx={{ mt: 1.5, maxWidth: 760, mx: 'auto', color: 'rgba(255,255,255,0.78)', lineHeight: 1.8 }}>
          Hubungi Junius untuk update harga coming soon, promo, ketersediaan
          unit, dan jadwal test drive dari BYD BSD Serpong.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Button href={waLink} target='_blank' rel='noopener noreferrer' variant='contained' sx={buttonPrimary}>
            Chat WhatsApp Junius
          </Button>
          <Button component={RouterLink} to='/pricing' variant='outlined' sx={buttonGhost}>
            Cek harga model BYD lain
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const eyebrow = {
  color: '#4c5867',
  fontWeight: 800,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  fontSize: '0.82rem',
};

const eyebrowDark = {
  display: 'inline-flex',
  px: 1.2,
  py: 0.65,
  borderRadius: '999px',
  backgroundColor: 'rgba(255,255,255,0.12)',
  border: '1px solid rgba(255,255,255,0.2)',
  fontSize: '0.78rem',
  fontWeight: 900,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
};

const heroTitle = {
  mt: 1.6,
  fontSize: { xs: '2.25rem', sm: '3.2rem', md: '4.8rem' },
  fontWeight: 900,
  lineHeight: 0.98,
  maxWidth: 900,
};

const heroText = {
  mt: 1.5,
  maxWidth: 760,
  fontSize: { xs: '1rem', md: '1.08rem' },
  lineHeight: 1.8,
  color: 'rgba(255,255,255,0.9)',
};

const sectionTitle = {
  mt: 1,
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  color: '#111827',
  lineHeight: 1.05,
};

const sectionTitleDark = {
  fontSize: { xs: '2rem', md: '3rem' },
  fontWeight: 900,
  lineHeight: 1.05,
};

const bodyText = {
  color: '#4b5563',
  lineHeight: 1.8,
  fontSize: { xs: '1rem', md: '1.05rem' },
};

const infoCard = {
  p: 2.4,
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid rgba(17,24,39,0.08)',
  boxShadow: '0 12px 26px rgba(16,24,40,0.06)',
};

const imageCard = {
  overflow: 'hidden',
  borderRadius: '8px',
  backgroundColor: '#fff',
  border: '1px solid rgba(17,24,39,0.08)',
  boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
};

const buttonPrimary = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  backgroundColor: '#1f5fd1',
  '&:hover': { backgroundColor: '#184ca8' },
};

const buttonGhost = {
  px: 3.2,
  py: 1.1,
  borderRadius: '999px',
  textTransform: 'none',
  fontWeight: 900,
  color: '#fff',
  borderColor: 'rgba(255,255,255,0.68)',
  '&:hover': {
    borderColor: '#fff',
    backgroundColor: 'rgba(255,255,255,0.1)',
  },
};

export default M6DMDetail;
